<template>
  <div
    id="app"
    class="alignmentFix"
  >
    <SiteHeader
      v-if="!isLiteView()"
      :account-type="accountTypeComputed"
      :nb-header="pd_content.show_nb_header"
    />
    <maestro-bar
      v-if="isMaestro()"
      external="true"
      :return-link="maestroReturningUrl"
      return-label="Return to Home"
      :client-name="clientName"
      :profile-name="maestroRepName"
    />
    <router-view />
    <SiteFooter
      :us-only-text="pd_content.site_footer_us_only_flag || 'true'"
      :footer-content="pd_content.site_footer_content"
    />
    <perfMark name="mark_above_the_fold" />
  </div>
</template>

<script>
import '@fmr-ap109253/providence/dist/expand-collapse/expand-collapse';
import '@fmr-ap109253/providence/dist/footer-simple/footer-simple';
import '@fmr-ap109253/providence/dist/header-simple/header-simple';
import '@fmr-ap109253/providence/dist/pvd-icon/pvd-icon';
import '@fmr-ap109253/providence/dist/loading-spinner/loading-spinner';
import '@fmr-ap109253/providence/dist/system-message/system-message';
import '@fmr-ap109253/providence/dist/layer-modal/layer-modal';
import '@fmr-ap109253/providence/dist/pvd-popover/pvd-popover';
import '@fmr-pr103625/maestro-shared';
import SiteHeader from './components/SiteHeader.vue';
import SiteFooter from './components/SiteFooter.vue';
import dataHelper from './mixins/dataHelper';
import utility from './mixins/utility';

export default {
  components: {
    SiteHeader,
    SiteFooter,
  },
  mixins: [dataHelper, utility],
  computed: {
    accountTypeComputed() {
      let prefix = '';
      if (this.pd_content.site_header_prefix) {
        prefix = this.pd_content.site_header_prefix === 'null' ? '' : this.pd_content.site_header_prefix;
      }
      const headerText = this.pd_content.site_header_text ? this.pd_content.site_header_text : '';
      return `${prefix} ${headerText}`.trim();
    },
    maestroRepName() {
      return window.queries.repName || 'Fidelity Representative';
    },
    maestroReturningUrl() {
      return window.queries.exitUrl || `${this.pd_envConfig.maestroURL}/stage`;
    },
    clientName() {
      if (this.pu_firstName || this.pu_lastName) {
        return `${this.pu_firstName || ''} ${this.pu_lastName || ''}`;
      }
      return '';
    },
  },
  beforeMount: () => {
    window.performance.mark('mark_fully_visible');
  },
};
</script>

<style lang="scss">
  /*base styles*/
  @import '~@fmr-ap109253/providence/scss/global/scaffolding.scss';
  /*anchor*/
  @import '~@fmr-ap109253/providence/scss/anchor/styles/_base.scss';
  /*button*/
  @import '~@fmr-ap109253/providence/scss/button/styles/_base.scss';
  @import '~@fmr-ap109253/providence/scss/button/styles/_btn-action.scss';
  @import '~@fmr-ap109253/providence/scss/button/styles/btn-ghost-action';
  /*button row*/
  @import '~@fmr-ap109253/providence/scss/button-row/styles/_base.scss';
  /*checkbox*/
  @import '~@fmr-ap109253/providence/scss/checkbox/styles/base';
  /*description list*/
  @import '~@fmr-ap109253/providence/scss/description-list/styles/base';
  /*display row*/
  @import '~@fmr-ap109253/providence/scss/display-row/styles/_base.scss';
  /*form row*/
  @import '~@fmr-ap109253/providence/scss/form-row/styles/_base.scss';

  /*heading*/
  @import '~@fmr-ap109253/providence/scss/heading/styles/_base.scss';
  @import '~@fmr-ap109253/providence/scss/heading/styles/_page-heading.scss';
  @import '~@fmr-ap109253/providence/scss/heading/styles/_size-default.scss';
  @import '~@fmr-ap109253/providence/scss/heading/styles/_size-large.scss';
  @import '~@fmr-ap109253/providence/scss/heading/styles/_size-xlarge.scss';
  @import '~@fmr-ap109253/providence/scss/heading/styles/_size-xxlarge.scss';
  /*input*/
  @import '~@fmr-ap109253/providence/scss/input/styles/_base.scss';
  @import '~@fmr-ap109253/providence/scss/input/styles/_utility-sizes.scss';
  /*label*/
  @import '~@fmr-ap109253/providence/scss/label/styles/_base.scss';
  /*lists*/
  @import '~@fmr-ap109253/providence/scss/list/styles/base';
  @import '~@fmr-ap109253/providence/scss/list/styles/list-bullet';
  @import '~@fmr-ap109253/providence/scss/list/styles/list-number';
  @import '~@fmr-ap109253/providence/scss/list/styles/size-small';
  @import '~@fmr-ap109253/providence/scss/list/styles/size-xsmall';
  /*paragraph*/
  @import '~@fmr-ap109253/providence/scss/paragraph/styles/base';
  @import '~@fmr-ap109253/providence/scss/paragraph/styles/size-xsmall';
  @import '~@fmr-ap109253/providence/scss/paragraph/styles/size-small';
  @import '~@fmr-ap109253/providence/scss/paragraph/styles/size-xlarge';
  /*select*/
  @import '~@fmr-ap109253/providence/scss/select/styles/_base.scss';
  /*toggle*/
  @import '~@fmr-ap109253/providence/scss/toggle-button/styles/_base.scss';
  /*utility*/
  @import '~@fmr-ap109253/providence/scss/utility/utility.scss';
  /*button*/
  @import '~@fmr-ap109253/providence/scss/button/styles/_size-small';
  @import '~@fmr-ap109253/providence/scss/button/styles/_btn-secondary';
  /*anchor*/
  @import '~@fmr-ap109253/providence/scss/anchor/styles/base';

  /* radio buttons */
  @import '~@fmr-ap109253/providence/scss/radio-button/styles/_base.scss';

  @import '~@fmr-ap109253/providence/scss/form-row/styles/_full-name';
  @import '~@fmr-ap109253/providence/scss/form-row/styles/_month-day-year';

  @import '~@fmr-ap109253/providence/scss/card/styles/base';
  @import '~@fmr-ap109253/providence/scss/form-row/styles/form-row-stacked';

  .container-divider {
    border-bottom: 0 !important;
    border-top: 1px solid #ccc;
  }
  fieldset {
    margin: 0;
    padding: 0;
    border: none;
  }

  .maestro-banner__prefill-for {
    white-space: nowrap;
  }
</style>
